export default __webpack_public_path__ + "6dc9dd06e4076a95859b9aeba7672233.svg";